// ...existing code...
import { useCallback, useEffect, useRef } from 'react';
import { useLazyHealthCheckQuery } from './redux/healthCheck';

export function useTimedPolling(durationMs: number = 30000, intervalMs: number = 5000) {
    const [trigger] = useLazyHealthCheckQuery();
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const startTimeRef = useRef<number>(0);
    const elapsedTimeRef = useRef<number>(0);

    const poll = useCallback(() => {
        const now = Date.now();
        const elapsed = now - startTimeRef.current;
        elapsedTimeRef.current = elapsed;

        if (elapsed >= durationMs) {
            return;
        }

        trigger();
        timeoutRef.current = setTimeout(poll, intervalMs);
    }, [durationMs, intervalMs, trigger]);

    useEffect(() => {
        startTimeRef.current = Date.now();
        elapsedTimeRef.current = 0;
        trigger();
        timeoutRef.current = setTimeout(poll, intervalMs);

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [durationMs, intervalMs, trigger, poll]);

}
